import { GET_STAFF, GET_STAFF_SUCCESS, GET_STAFF_FAILURE } from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STAFF:
      return { ...state, loading: true };
    case GET_STAFF_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_STAFF_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getStaffReducer;
